import React from 'react';

// Port of whatsapp-console-frontend `src/pages/FbAdvertisment/adTypeIcons.js`
// with the `static/adTypeIcons/*.svg` glyphs inlined.

const ICON_STYLE: React.CSSProperties = { width: '22px', height: '22px' };

const BOX_STYLE: React.CSSProperties = {
  width: '36px',
  height: '36px',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

const Glyph = ({
  color,
  children,
}: {
  color: string;
  children: React.ReactNode;
}): React.ReactElement => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="1.8"
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    style={{ ...ICON_STYLE, color }}
  >
    {children}
  </svg>
);

const WhatsAppAdIcon = ({ color }: { color: string }) => (
  <Glyph color={color}>
    <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
    <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
  </Glyph>
);

const WhatsAppStatusAdIcon = ({ color }: { color: string }) => (
  <Glyph color={color}>
    <path d="M8.56 3.69a9 9 0 0 0 -2.92 1.95" />
    <path d="M3.69 8.56a9 9 0 0 0 -.69 3.44" />
    <path d="M3.69 15.44a9 9 0 0 0 1.95 2.92" />
    <path d="M8.56 20.31a9 9 0 0 0 3.44 .69" />
    <path d="M15.44 20.31a9 9 0 0 0 2.92 -1.95" />
    <path d="M20.31 15.44a9 9 0 0 0 .69 -3.44" />
    <path d="M20.31 8.56a9 9 0 0 0 -1.95 -2.92" />
    <path d="M15.44 3.69a9 9 0 0 0 -3.44 -.69" />
    <circle cx="12" cy="12" r="2.25" fill="currentColor" stroke="none" />
  </Glyph>
);

const WebsiteAdIcon = ({ color }: { color: string }) => (
  <Glyph color={color}>
    <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
    <path d="M3.6 9h16.8" />
    <path d="M3.6 15h16.8" />
    <path d="M11.5 3a17 17 0 0 0 0 18" />
    <path d="M12.5 3a17 17 0 0 1 0 18" />
  </Glyph>
);

const box = (children: React.ReactNode): React.ReactElement => (
  <div style={BOX_STYLE}>{children}</div>
);

const AD_TYPE_ICONS: Record<string, React.ReactElement> = {
  ctwa: box(<WhatsAppAdIcon color="#109d59" />),
  whatsapp_status: box(<WhatsAppStatusAdIcon color="#109d59" />),
  website_traffic: box(<WebsiteAdIcon color="#1877F2" />),
  // Website → WhatsApp hybrid: website glyph in the WhatsApp green treatment.
  website_to_whatsapp: box(<WebsiteAdIcon color="#109d59" />),
};

export default AD_TYPE_ICONS;
